import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  CircularProgress,
  Divider,
} from "@mui/material";

const ApiTester = () => {
  const [url, setUrl] = useState("");
  const [payload, setPayload] = useState(`{
  "externalUserId": ""
}`);
  const [response, setResponse] = useState("");
  const [loading, setLoading] = useState(false);

  const hitApi = async () => {
    if (!url) {
      alert("Please enter API URL");
      return;
    }

    setLoading(true);
    setResponse("Loading...");

    try {
      const res = await axios.post(url, JSON.parse(payload), {
        headers: { "Content-Type": "application/json" },
      });

      setResponse(JSON.stringify(res.data, null, 2));
    } catch (err) {
      setResponse(
        JSON.stringify(
          err.response
            ? { status: err.response.status, data: err.response.data }
            : { error: err.message },
          null,
          2
        )
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: 4,
      }}
    >
      <Paper
        elevation={10}
        sx={{
          width: "100%",
        //   maxWidth: 900,
          borderRadius: 4,
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            p: 3,
            background: "linear-gradient(90deg, #6366f1, #22d3ee)",
            color: "#fff",
          }}
        >
          <Typography variant="h5" fontWeight={700}>
            API Tester
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            Test REST APIs with custom payloads
          </Typography>
        </Box>

        <Box sx={{ p: 4 }}>
          {/* API URL */}
          <Typography variant="subtitle2" gutterBottom>
            API Endpoint
          </Typography>
          <TextField
            fullWidth
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            // placeholder="https://dev.convoze.com/apis/manager-panel/mpokketcrm"
            size="small"
          />

          {/* Payload */}
          <Typography variant="subtitle2" sx={{ mt: 3 }}>
            Request Payload (JSON)
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={6}
            value={payload}
            onChange={(e) => setPayload(e.target.value)}
            sx={{
              mt: 1,
              "& textarea": {
                fontFamily: "JetBrains Mono, monospace",
                fontSize: 13,
              },
            }}
          />

          {/* Action */}
          <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
            <Button
              variant="contained"
              onClick={hitApi}
              disabled={loading}
              sx={{
                px: 4,
                background: "linear-gradient(90deg, #6366f1, #22d3ee)",
              }}
            >
              {loading ? (
                <>
                  <CircularProgress size={18} sx={{ mr: 1 }} />
                  Sending
                </>
              ) : (
                "Send Request"
              )}
            </Button>
          </Box>

          <Divider sx={{ my: 4 }} />

          {/* Response */}
          <Typography variant="subtitle2">Response</Typography>
          <Paper
            variant="outlined"
            sx={{
              mt: 1,
              p: 2,
              backgroundColor: "#020617",
              color: "#e5e7eb",
              whiteSpace: "pre-wrap",
              fontFamily: "JetBrains Mono, monospace",
              fontSize: 13,
              maxHeight: 350,
              overflow: "auto",
              borderRadius: 2,
            }}
          >
            {response || "// Response will appear here"}
          </Paper>
        </Box>
      </Paper>
    </Box>
  );
};

export default ApiTester;
